import React from "react";
import { Mail } from "lucide-react";
import { LANDING } from "@/constants/testIds";
import { LOGO_ICON_URL, SUPPORT_EMAIL, COMPANY } from "@/lib/constants";

const LEGAL_LINKS = [
  { label: "About Us", href: "https://www.emdpay.in/about-us" },
  { label: "Contact Us", href: "https://www.emdpay.in/contact-us" },
  { label: "Privacy Policy", href: "https://www.emdpay.in/privacy-policy" },
  { label: "Terms & Conditions", href: "https://www.emdpay.in/terms-and-conditions" },
  { label: "Refund & Cancellation Policy", href: "https://www.emdpay.in/refund" },
  {
    label: "Customer Grievance Redressal Policy",
    href: "https://www.emdpay.in/customer_grievance",
  },
];

export const Footer = () => {
  return (
    <footer
      data-testid={LANDING.footer}
      className="relative bg-[#FAFAF7] border-t border-[#E5E5E0] pt-20 pb-10"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <img src={LOGO_ICON_URL} alt="" className="h-8 w-8 object-contain" />
              <span className="font-serif text-xl tracking-tight">
                EMD<span className="text-[#F25C2A]">pay</span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-[#4A4A4A] leading-relaxed">
              A marketplace for education-fee &amp; professional-service
              payments — with flight, hotel, bus booking and credit card
              discovery built in.
            </p>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              data-testid={LANDING.footerEmail}
              className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#0A0A0A] hover:text-[#F25C2A] transition-colors"
            >
              <Mail size={16} />
              {SUPPORT_EMAIL}
            </a>
          </div>

          <div className="md:col-span-7">
            <p className="text-[11px] uppercase tracking-[0.22em] font-semibold text-[#737373]">
              Quick Links
            </p>
            <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
              {LEGAL_LINKS.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-[#0A0A0A] hover:text-[#F25C2A] transition-colors"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#E5E5E0] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-[#737373]">
            © {new Date().getFullYear()} {COMPANY}. All rights reserved.
            EMDpay operates a marketplace for fee &amp; service payments —
            transactions are processed via regulated banking partners.
          </p>
          <div className="flex items-center gap-2 flex-wrap">
            <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold text-[#4A4A4A] bg-white border border-[#E5E5E0] rounded-full px-3 py-1">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
              Verified sellers
            </span>
            <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold text-[#4A4A4A] bg-white border border-[#E5E5E0] rounded-full px-3 py-1">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
              Secure payments
            </span>
            <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold text-[#4A4A4A] bg-white border border-[#E5E5E0] rounded-full px-3 py-1">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
              Made in India
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};
